/* eslint-disable */

// react
import React, {useEffect, useState} from "react";

//MUI
import { Box, Stack, Grid, FormControl, TextField, } from "@mui/material";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import USelectBox from "../../components/mui/USelectBox";
import UButton from "../../components/mui/UButton";
import UTable from "../../components/mui/UTable";

// API
import { API } from "../../config";
import { fni18n } from "../../services/commonService";
import { getAPI} from "../../services/commonService";
import AuthenticationService from "../auth/AuthenticationService";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

export default function EndOfShiftPage() {
  const userLoginId = AuthenticationService.getLoggedInUserID();
  const columns = [
    {
      field: 'id',
      headerName: 'id',
      width: 50,
      align: "center",
      headerAlign: "center",
      hide:true,
    },
    {
      field: 'endDt',
      headerName: '마감일시',
      width: 100,
      align: "center",
      headerAlign: "center",
      valueFormatter: (params) => {
        return (
          <div
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {params.value}
          </div>
        );
      },
    },
    {
      field: 'shiftNo',
      headerName: '교대번호',
      width: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: 'machId',
      headerName: '기기번호',
      width: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: 'userId',
      headerName: '사용자ID',
      width: 50,
      align: "center",
      headerAlign: "center",
    },
    {
      field: 'startMachBalance',
      headerName: '개시잔액',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'inTotAmnt',
      headerName: '입금',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'envelopeAmnt',
      headerName: '봉투입금함',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'outTotAmnt',
      headerName: '출금',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'addCashAmnt',
      headerName: '보충',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'removeCashAmnt',
      headerName: '회수',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'endOfShiftNet',
      headerName: '정산금액',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          if(params.value<0){
            return (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "right",
                  color: "red",
                }}
              >
                {"$"+Number(params.value).toLocaleString("en-US")}
              </div>
            );
          }
          return "$"+Number(params.value).toLocaleString("en-US")
        }
        else {
          return params.value
        }
      },
    },
    {
      field: 'endMachBalance',
      headerName: '마감잔액',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'endTransitcstBalance',
      headerName: '보회함',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'endRejtBalance',
      headerName: '리젝함',
      width: 100,
      align: "right",
      headerAlign: "center",
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        if(!isNaN(params.value)){
          return "$"+Number(params.value).toLocaleString("en-US")
        }else {
          return params.value
        }
      },
    },
    {
      field: 'notes',
      headerName: '비고',
      width: 150,
      align: "center",
      headerAlign: "center",
      
    },
  ];

  const [stores, setStore] = useState([]);
  const [retailers, setRetailers] = useState([]);
  const [brands, setBrands] = useState([]);
  const [machines, setMachineList] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const date = new Date();
  const now = date.toISOString().slice(0, 10);
  const [search, setSearch] = useState({
    // storeCd:"N/A",             //스토어
    // brandCd:"N/A",              //브랜드
    startDate:now,            //시작일
    // machId:"N/A",                 //기번
  });
  const [tableData, setTableData] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  //화면 로드 시
  useEffect(() => {
    const getLoadData = async () => {
      try {
        await Promise.all([
          loadComboBoxBranchGroup(),
          loadComboBoxBranch()
        ]);
      } catch (e) {
        console.error('초기 로딩 실패:', e.message);
      }
    };
    getLoadData();
  }, []);

  useEffect(() => {
    if (!isFirstLoad) return;
    if (search.storeCd) {
      loadDataGrid();
      setIsFirstLoad(false);
    }
  }, [search]);

  const clearSearchVal = ()=>{
    setSearch({
        ...search,
        ['storeCd']: 'N/A',
    });
    setMachineList([]);
    setBrands([]);
  }

  // 콤보박스 데이터
  const loadComboBoxBranchGroup = async () => {
    try {
        const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
        const _inputData = res.data.result.map((m) => ({
            cd: m.id,
            name: m.branchGroupNm,
        }));
        setRetailers(_inputData);
        // await loadComboBoxBranch(_inputData[0].cd);
    } catch (e) {
        console.error(e.message);
    }
  };
  const loadComboBoxBranch = async (param) => {
    try {
      const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
      const _inputData = res.data.result.map((m) => ({
        cd: m.storeCd,
        name: m.storeNm,
      }));
      setStore(_inputData);
      if (_inputData.length > 0){
        // await loadComboBoxBrand(_inputData[0].cd);
        await loadComboBoxMachine(_inputData[0].cd);
      } else {
        clearSearchVal()
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  const loadComboBoxBrand = async (store) => {
    try {
      const res = await getAPI(API.COMMON.BRAND, {
        userId: userLoginId,
        store: store,
      });
      const _inputData = res.data.result.map((m) => ({
        cd: m.brandCd,
        name: m.brandNm,
      }));
      if (_inputData.length > 0) {
        setSearch({
          ...search,
          ["brandCd"]: _inputData[0].cd,
          ["storeCd"]: store,
        });
      } else {
        setSearch({
          ...search,
          ["brandCd"]: "N/A",
          ["storeCd"]: store,
        });
      }
      setBrands(_inputData);
    } catch (e) {
      console.error(e.message);
    }
  };
    
  // 기번 가져오기
  const loadComboBoxMachine = async (store) => {
    try {
      const res = await getAPI(API.COMMON.MACHINE + store);
      const _inputData = res.data.result.map((m) => ({
        cd: m.machId,
        name: m.machId,
      }));
      setMachineList(_inputData);
      if (_inputData.length > 0) {
        setSearch({
          ...search,
          ["machId"]: _inputData[0].cd,
          ["storeCd"]: store,
        });
      } else {
        setSearch({
          ...search,
          ["machId"]: "N/A",
          ["storeCd"]: store,
        });
      }
    } catch (e) {
      console.error(e.message);
    }
  };

  //화면들어올때 자동조회 - 거래집계
  const loadDataGrid = async() => {
      const res = await getAPI(API.CASH.ENDDAY, search);
      const inputData = res.data.result;
      setTableData(inputData);
  }

  //버튼 클릭
  async function onButtonClick(dvsn) {
    if(dvsn == "조회"){
      loadDataGrid();
    } else {
      handleRowSelect(dvsn);
    }
  };

  //폼 팝업
  const handleFormOpen = () => {
    setFormOpen(true);
  };
  const handleFormClose = () => {
    setFormOpen(false);
  };

  //콤보박스 아이템 선택
  const onChangeCombo = (e) => {
    const { name, value } = e.target;
    setSearch({
      ...search,
      [name]: value,
    });
    if (name === "bizTy") {
        loadComboBoxBranch(value);
    }
    if (name === "storeCd") {
      loadComboBoxMachine(value);
      // loadComboBoxBrand(value);
    }
  };

  const onCheckboxChange = (e) => {
    const { name, value } = e.target;
    setSearch({
      ...search,
      [name]: e.target.checked === true ? "Y" : "N",
    });
  };
     
  return (
      <div className="main-container">
          <Box className="header">
              <Grid container>
                  <Grid item xs={10}>
                    {/* 상단메뉴명 */}
                    <UBreadCrumbs title={'자금정보'} subtitle={'마감보고서'} />
                  </Grid>
                  <Grid item xs={2}>
                    {/* 툴바 버튼 */}
                    <Stack
                        direction="row"
                        justifyContent="flex-end"
                        alignItems="flex-start"
                        spacing={4}
                    >
                    </Stack>
                  </Grid>
              </Grid>
          </Box>

          <div className="contents">
              <Box>
                  <TableContainer className="table-container">
                  <Table className="table" size="small">
                      <TableBody>
                          <TableRow className="table-row-header">
                            <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                            <TableCell className="table-cell">
                                <USelectBox
                                    name="bizTy"
                                    items={retailers}
                                    onItemChange={onChangeCombo}
                                />
                            </TableCell>
                              {/* 점번선택 */}
                              <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                              <TableCell className="table-cell">
                                  <USelectBox id="storeCd" name="storeCd" items={stores} onItemChange={onChangeCombo} defaultValue={search.storeCd}/>
                              </TableCell>
                              {/* 기번선택 */}
                              <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                              <TableCell className="table-cell"> 
                                <USelectBox
                                id="machId"
                                name="machId"
                                items={machines}
                                defaultValue={search.machId}
                                onItemChange={onChangeCombo}
                                />
                              </TableCell>
                              <TableCell className="table-cell-title">{fni18n('마감일자')}</TableCell>
                              <TableCell className="table-cell" >
                                {/* 날짜선택 */}
                                <FormControl sx={{ width: 150 }}>
                                  <TextField
                                    name="startDate"
                                    fullWidth
                                    type="date"
                                    size="small"
                                    defaultValue={now}
                                    onChange={onChangeCombo}
                                    inputProps={{ style: { fontSize: 13 } }} 
                                  />
                                </FormControl>
                              </TableCell>
                          </TableRow>
                      </TableBody>
                  </Table>
                  </TableContainer>
                  <div className="search">
                    <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                  </div>
              </Box>
              <UTable columns={columns} rows={tableData} rowPerPage={11}/>
          </div>
      </div>
  );
}